import { State } from "../store";

export const coachSelector = (state: State) => state.session.coach;

export const orgSelector = (state: State) => state.session.org;

export const orgsSelector = (state: State) => state.session.orgs;

export const activeOrgIdSelector = (state: State) =>
  state.session.activeOrgId;

export const isSwitchingOrgSelector = (state: State) =>
  state.session.isSwitchingOrg;

export const permissionsSelector = (state: State) =>
  state.session.permissions;

export const subscriptionSelector = (state: State) =>
  state.session.subscription;

export const hasTeamMembersSelector = (state: State) =>
  state.session.hasTeamMembers;

export const userIdSelector = (state: State) => state.session.userId;

export const roleKeySelector = (state: State) => state.session.roleKey;

export const memberTypeSelector = (state: State) => state.session.memberType;

export const resetSelector = (state: State) => state.session.reset;

export const initialisedSelector = (state: State) => state.session.initialised;

export const needsRefreshAfterRehydrateSelector = (state: State) =>
  state.session.needsRefreshAfterRehydrate;

export const initWithUserSelector = (state: State) =>
  state.session.initWithUser;

export const setActiveOrgIdSelector = (state: State) =>
  state.session.setActiveOrgId;

export const setSwitchingOrgSelector = (state: State) =>
  state.session.setSwitchingOrg;
